import type { DataMode } from '@infra/licence/ActivationClaims';
import type { TenantScopedRepository } from '@infra/tenancy/TenantScopedRepository';
import type { Salarie } from '@shared/types/Salarie';
import type { Bulletin } from '@shared/types/Bulletin';
import type { Ecriture } from '@shared/types/Ecriture';
import type { Facture } from '@shared/types/Facture';
import type { CentreAnalytique } from '@shared/types/CentreAnalytique';

export interface RepositoriesBundle {
  readonly dataMode: DataMode;
  readonly salaries: TenantScopedRepository<Salarie>;
  readonly bulletins: TenantScopedRepository<Bulletin>;
  readonly ecritures: TenantScopedRepository<Ecriture>;
  readonly factures: TenantScopedRepository<Facture>;
  readonly centresAnalytiques: TenantScopedRepository<CentreAnalytique>;
  isRemoteOnline(): boolean;
}

export class RemotePersistenceOfflineError extends Error {
  constructor(message = 'Serveur métier indisponible — modifications suspendues.') {
    super(message);
    this.name = 'RemotePersistenceOfflineError';
  }
}
